type ComponentCategory = 'atoms' | 'molecules' | 'organisms' | 'templates' | 'pages';

export const storyTitle = (name: string, category: ComponentCategory): string =>
  `${category}/${name}`;
